/**
 * @generated SignedSource<<a7a42d0907d8ad6cb7e6651cc3a0a394>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type SignupUserInput = {
  bio?: string | null | undefined;
  displayName: string;
  github?: string | null | undefined;
  googleScholar?: string | null | undefined;
  image?: any | null | undefined;
  linkedin?: string | null | undefined;
  location?: string | null | undefined;
  signup: SignupInput;
  subscribePromotionalNewsletter?: boolean | null | undefined;
  username: string;
  website?: any | null | undefined;
};
export type SignupInput = {
  email?: EmailSignupVerficationInput | null | undefined;
  oauth2?: Oauth2SignupInput | null | undefined;
};
export type EmailSignupVerficationInput = {
  id: string;
  token: string;
};
export type Oauth2SignupInput = {
  secret: string;
};
export type SetupUserPageMutation$variables = {
  input: SignupUserInput;
};
export type SetupUserPageMutation$data = {
  readonly signupUser: {
    readonly node: {
      readonly id: string;
    };
  };
};
export type SetupUserPageMutation = {
  response: SetupUserPageMutation$data;
  variables: SetupUserPageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UserEdge",
    "kind": "LinkedField",
    "name": "signupUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SetupUserPageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SetupUserPageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89905da50952346ebf7798177f23946c",
    "id": null,
    "metadata": {},
    "name": "SetupUserPageMutation",
    "operationKind": "mutation",
    "text": "mutation SetupUserPageMutation(\n  $input: SignupUserInput!\n) {\n  signupUser(input: $input) {\n    node {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "57570afbae496669d97bd0c7c80c7018";

export default node;
